import React, { useState, useCallback, useEffect } from "react";

const PanoramaViewer = () => {
  const [showOverlay, setShowOverlay] = useState(true);
  const [showExitButton, setShowExitButton] = useState(false);

  const handleOverlayClick = () => {
    setShowOverlay(false);
    setShowExitButton(true);
  };

  const handleExit = useCallback(() => {
    setShowOverlay(true);
    setShowExitButton(false);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        handleExit();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleExit]);

  return (
    <div className="w-full mt-[90px] h-[600px] md:h-[800px] relative">
      <iframe
        src="https://panorama.ufo3d.com/CMRYMJVM/"
        title="Union Center Panorama"
        className="w-full h-full border-0"
        allowFullScreen
      ></iframe>
      {showOverlay && (
        <div
          className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center cursor-pointer"
          onClick={handleOverlayClick}
        >
          <div className="text-white text-lg font-semibold p-4 bg-blue-500 rounded font-roboto">
            Click Here to Start 3D Tour
          </div>
        </div>
      )}
      {showExitButton && (
        <div className="absolute top-4 right-4 z-10">
          <button
            onClick={handleExit}
            className="bg-red-500 text-white px-4 py-2 rounded shadow hover:bg-red-600 transition-colors"
          >
            Exit 3D Tour
          </button>
        </div>
      )}
      {!showOverlay && (
        <div className="absolute bottom-4 left-4 text-white text-sm bg-black bg-opacity-50 p-2 rounded">
          Press ESC to exit the 3D tour
        </div>
      )}
    </div>
  );
};

export default PanoramaViewer;
